
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/we-queue-for-you/processing",
      function () {
        return require("private-next-pages/we-queue-for-you/processing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/we-queue-for-you/processing"])
      });
    }
  